import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=532cee80&"
import script from "./PdfView.vue?vue&type=script&lang=js&"
export * from "./PdfView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports